import React, { useEffect, useRef, useState } from "react";

import api from "../../../services/api.js";

import GraphicCircle from "./GraphicCircle.js";
import { Loading } from "../../loading/index.js";

import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";
import ArrowDownSvg from "../../../assets/icons/icon-arrow-down.svg";
import * as S from './styles';
import { theme } from "../../../styles/theme.js";
import { TaglineM, TaglineP, TaglinePSpan } from "../../../styles/stylesTypography.js";

export const compendioG = "@compendioG";

const userData = JSON.parse(localStorage.getItem("@userinfo"));

const CircleData = ({ ...props }) => {
    const [responsaveis, setResponsaveis] = useState([]);
    const [selectedResponsavel, setSelectedResponsavel] = useState(null);
    const [quantidadeReceitas, setQuantidadeReceitas] = useState(0);
    const [receitas, setReceitas] = useState(0);
    const [type, setType] = useState("");
    const [numeroArt, setNumeroArt] = useState(0);
    const [isLoading, setIsloading] = useState(true);
    const [credits, setCredits] = useState(0);
    const [maxQuantity, setMaxQuantity] = useState(0);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [creaArtsData, setCreaArtsData] = useState(null);
    const [isCreaLoading, setIsCreaLoading] = useState(false);
    const [selectedRegistroLinha, setSelectedRegistroLinha] = useState("");
    const selectRef = useRef(null);

    const buildRegistroLinha = (item) => {
        const tipoRegistro = String(item?.tipo_registro ?? "").toLowerCase();
        const ufRegistro = item?.uf_registro ?? item?.estado ?? "";
        const documento = item?.documento ?? "";
        const numeroBase = documento || item?.crea || item?.crea_numero || "";

        if (!numeroBase) return "";

        if (tipoRegistro === "visto") {
            return `VISTO: ${numeroBase}`;
        }

        if (tipoRegistro.includes("nacional")) {
            return `NACIONAL AGR: ${numeroBase}`;
        }

        const siglaRegistro = String(ufRegistro).toUpperCase() === "NACIONAL" ? "CFTA" : "CREA";
        return `${siglaRegistro}${ufRegistro ? `-${ufRegistro}` : ""}: ${numeroBase}`;
    };

    const getRecipes = async () => {
        try {
            const endpoint = props.useCreaArts ? `/agronomos/crea/arts` : `/home/receitas-art`;
            const response = await api.get(endpoint);
            const responseSave = response.data.data || response.data || [];

            const formattedData = (Array.isArray(responseSave) ? responseSave : []).map((item) => ({
                responsavel: item.responsavel_tecnico_nome || item.responsavel || item.nome || '',
                receitas_restantes: item.receitas_restantes || 0,
                quantidade_receitas
                : item.quantidade_receitas
                 || 0,
                tipo: item.tipo || 'Receitas',
                numero_art: item.numero_art || item.ultima_art_numero || '',
                tipo_registro: item.tipo_registro,
                uf_registro: item.uf_registro,
                documento: item.documento,
                crea: item.crea,
                crea_numero: item.crea_numero,
                estado: item.estado,
            }));

            setResponsaveis(formattedData);

            if (formattedData.length > 0) {
                let initialIndex = typeof props.initialIndex === 'number' ? props.initialIndex : 0;
                if (initialIndex === -1) initialIndex = formattedData.length - 1;
                if (initialIndex < 0 || initialIndex >= formattedData.length) initialIndex = 0;
                const initial = formattedData[initialIndex];
                setSelectedResponsavel(initial.responsavel);
                setReceitas(initial.receitas_restantes);

                const pathname = window.location?.pathname || '';
                if (pathname.startsWith('/agronomos')) {
                    setQuantidadeReceitas(initial.receitas_restantes);
                } else {
                    setQuantidadeReceitas(initial.quantidade_receitas);
                }

                setType(initial.tipo);
                setNumeroArt(initial.numero_art)
                setSelectedRegistroLinha(buildRegistroLinha(initial));
            } else {
                setSelectedResponsavel(null);
                setReceitas(0);
                setQuantidadeReceitas(0);
                setType("");
                setNumeroArt(0);
                setSelectedRegistroLinha("");
            }
            setIsloading(false);

        } catch (error) {
            console.error("Erro ao buscar receitas:", error);
        } finally {
            setIsloading(false);
        }
    };

    useEffect(() => {
        if (props.useCreaArts) {
            setIsloading(false);
            setResponsaveis([]);
            setSelectedResponsavel(null);
            return;
        }
        getRecipes();
    }, [props.useCreaArts]);

    useEffect(() => {
        if (!props.creaId) {
            setCreaArtsData(null);
            return;
        }

        let isActive = true;

        const loadCreaArts = async () => {
            try {
                setIsCreaLoading(true);
                const response = await api.get(`/agronomos/crea/arts/${props.creaId}`);
                const payload = response.data?.data ?? response.data ?? null;
                if (isActive) {
                    setCreaArtsData(payload);
                }
            } catch (error) {
                if (isActive) {
                    setCreaArtsData(null);
                }
            } finally {
                if (isActive) {
                    setIsCreaLoading(false);
                }
            }
        };

        loadCreaArts();

        return () => {
            isActive = false;
        };
    }, [props.creaId]);

    const handleSelectValue = (selected) => {
        setSelectedResponsavel(selected);

        const found = responsaveis.find((item) => item.responsavel === selected);
        if (found) {
            setReceitas(found.receitas_restantes);
            const pathname = window.location?.pathname || '';
            if (pathname.startsWith('/agronomos')) {
                setQuantidadeReceitas(found.receitas_restantes);
            } else {
                setQuantidadeReceitas(found.quantidade_receitas);
            }
            setType(found.tipo);
            setNumeroArt(found.numero_art);
            setSelectedRegistroLinha(buildRegistroLinha(found));
        } else {
            setSelectedRegistroLinha("");
        }
    };

    const getInitials = (name) => {
        if (!name) return '';

        const cleanedName = name.replace(/\([^)]*\)/g, '').trim();

        const nameParts = cleanedName
            .split(' ')
            .filter(part => part.toLowerCase() !== '');

        if (nameParts.length >= 2) {
            return nameParts
                .slice(0, 2)
                .map(part => part.charAt(0).toUpperCase())
                .join('');
        } else if (nameParts.length === 1) {
            return nameParts[0].substring(0, 2).toUpperCase();
        }

        return '';
    };

    const getMaxQuantity = async () => {
        try {
            const response = await api.get(`planos/qtd-receitas`)

            setMaxQuantity(response.data.data.limite_receitas);
            const saldoData = response.data.data.saldo_receitas;

            setCredits(saldoData)

        } catch (error) {
            console.error("Erro ao buscar saldo:", error); 
        }
    }

    useEffect(() => {
        getMaxQuantity();
    }, [])

    const isAgronomosPage = window.location.pathname === '/agronomos';
    const isCreaArtsMode = Boolean(props.useCreaArts);
    const hasCreaArtsData = Boolean(props.dataAgronomo);
    const agronomoLabel = props.dataAgronomo?.responsavel_tecnico_nome;
    const isStaticSingleOption = Boolean(agronomoLabel && isAgronomosPage);
    const currentCreaData = props.creaId && creaArtsData ? creaArtsData : props.dataAgronomo;
    const currentCreaType = currentCreaData?.tipo ?? currentCreaData?.creas?.[0]?.tipo;
    const currentEstado = currentCreaData?.estado ?? currentCreaData?.creas?.[0]?.estado;
    const currentCreaNumero = currentCreaData?.crea ?? currentCreaData?.crea_numero ?? currentCreaData?.creas?.[0]?.crea;

    const registroTipo = String(
        currentCreaData?.tipo_registro ?? currentCreaData?.creas?.[0]?.tipo_registro ?? ""
    ).toLowerCase();
    const registroUf = currentCreaData?.uf_registro ?? currentCreaData?.creas?.[0]?.uf_registro ?? currentEstado;
    const registroDocumento = currentCreaData?.documento ?? currentCreaData?.creas?.[0]?.documento;
    const registroNumeroBase = registroDocumento ?? currentCreaNumero ?? "";
    const registroLinha = registroTipo === "visto"
        ? `VISTO: ${registroNumeroBase}`
        : registroTipo.includes("nacional")
            ? `NACIONAL AGR: ${registroNumeroBase}`
            : `${String(registroUf ?? currentEstado).toUpperCase() === "NACIONAL" ? "CFTA" : "CREA"}-${registroUf ?? currentEstado}: ${registroNumeroBase}`;

    const isSP = currentEstado === "SP";
    const remainingValue = isSP
        ? (
            currentCreaData?.contratos_disponiveis ??
            currentCreaData?.contratos_restantes ??
            currentCreaData?.receitas_disponiveis ??
            currentCreaData?.receitas_restantes ??
            0
        )
        : (currentCreaData?.receitas_disponiveis ?? currentCreaData?.receitas_restantes ?? 0);
    const circleValue = props.dataAgronomo
        ? (props.creaId ? remainingValue : (props.dataAgronomo.quantidade_receitas ? props.dataAgronomo.quantidade_receitas : quantidadeReceitas))
        : receitas;
    const circleTypeLabel = isSP ? "Contratos" : "Receitas";
    const circleLoading = props.creaId ? isCreaLoading : isLoading;
    const shouldShowNotFound = !circleLoading && !props.dataAgronomo && responsaveis.length === 0;

    useEffect(() => {
        if (isStaticSingleOption) {
            setSelectedResponsavel(agronomoLabel);
        }
    }, [isStaticSingleOption, agronomoLabel]);

    const displayedLabel = isCreaArtsMode && !hasCreaArtsData
        ? "Dados não encontrados"
        : isLoading
        ? "Carregando dados..."
        : isStaticSingleOption
            ? agronomoLabel
            : (selectedResponsavel || (responsaveis[0]?.responsavel || "Nenhum agronomo encontrado"));
    const hasNoAgronomoResults = !isLoading && !props.dataAgronomo && responsaveis.length === 0;
    const isCardLoading = props.dataAgronomo ? circleLoading : isLoading;

    const canOpenDropdown = !isCreaArtsMode && !props.selecetDisabled && !isLoading && !isStaticSingleOption && responsaveis.length > 0;

    const toggleDropdown = () => {
        if (!canOpenDropdown) return;
        setIsDropdownOpen((prev) => !prev);
    };

    const filteredResponsaveis = (responsaveis || []).filter((item) =>
        (item?.responsavel || "").toLowerCase().includes((searchTerm || "").toLowerCase())
    );

    const handleOptionSelect = (responsavel) => {
        handleSelectValue(responsavel);
        setIsDropdownOpen(false);
        setSearchTerm("");
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
                setSearchTerm("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <S.Container className="circleData">
            <S.Wrapper isCardLoading={isCardLoading}>
                {props.NoSelecet || isCardLoading || hasNoAgronomoResults ? (null) :(
                    <S.ProfileCircle disabled={props.selecetDisabled} ref={selectRef}>
                        {displayedLabel === "Nenhum responsável" ? (
                            <S.Profile center={true}>
                                <TaglinePSpan>Nenhum responsável</TaglinePSpan>
                            </S.Profile>
                        ):(
                            <S.Profile
                                selectImage={props.selectImage}
                                disabled={props.selecetDisabled}
                                onClick={toggleDropdown}
                            >
                                <S.SelectedLabel selectImage={props.selectImage} disabled={props.selecetDisabled}>
                                    {displayedLabel}
                                </S.SelectedLabel>
                                {canOpenDropdown && (
                                    <S.ArrowIcon src={ArrowDownSvg} isOpen={isDropdownOpen} alt="" />
                                )}
                            </S.Profile>
                        )}
                        

                        {/* Adicionando a div circular com as iniciais do responsável */}
                        {selectedResponsavel && (
                            <S.InitialsCircle>
                                {getInitials(selectedResponsavel)}
                            </S.InitialsCircle>
                        )}

                        {isDropdownOpen && (
                            <S.SelectOptions selectImage={props.selectImage}>
                                <S.SearchInputContainer>
                                    <input
                                        type="text"
                                        placeholder="Buscar"
                                        value={searchTerm}
                                        autoFocus
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </S.SearchInputContainer>
                                <S.OptionsList>
                                    {filteredResponsaveis.length > 0 ? (
                                        filteredResponsaveis.map((data) => (
                                            <S.Option
                                                key={data.responsavel}
                                                selected={data.responsavel === selectedResponsavel}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOptionSelect(data.responsavel);
                                                }}
                                            >
                                                {data.responsavel}
                                            </S.Option>
                                        ))
                                    ) : (
                                        <S.EmptyOption>Nenhum resultado</S.EmptyOption>
                                    )}
                                </S.OptionsList>
                            </S.SelectOptions>
                        )}


                    </S.ProfileCircle>
                )}

                <S.CirclesContainer marginBottom={props.marginBottom} isCardLoading={isCardLoading}>
                {isCardLoading ? (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '150px' }}>
                        <Loading size="80px" color={theme.colors.green.Bandeira} />
                    </div>
                ) : props.dataAgronomo ? (
                    <>
                        <S.CircleData>
                            <GraphicCircle value={circleValue} />

                            <TaglineP color={theme.colors.gray.Cinza_2}>
                            {currentCreaData.estado === "RJ" ? (
                                <>
                                    {currentCreaType?.toUpperCase()}-{currentEstado}: {currentCreaNumero} <br/>

                                    Não é necessário ART <br/> para o estado do RJ
                                </>
                            ):(
                                <>
                                    {String(circleTypeLabel).toUpperCase()} RESTANTES
                                    <br/>
                                    {registroLinha}
                                </>
                            )}
                              
                            </TaglineP>
                        </S.CircleData>
                    </>
                ) : hasNoAgronomoResults ? (
                    <S.ContainerNorFound>
                        <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

                        <TaglinePSpan color={theme.colors.gray.Cinza_2}>
                            Nenhum agronomo encontrado
                        </TaglinePSpan>
                    </S.ContainerNorFound>
                ) : (
                    <>
                        {shouldShowNotFound ? (
                            <S.NotFound>
                                <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

                                <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                                    Nenhum responsavel <br/> técnico encontrado
                                </TaglineM>
                            </S.NotFound>
                        ) : (
                            <>
                                <S.CircleData>
                                    <GraphicCircle value={receitas} />

                                    {isLoading ? (
                                        <TaglineP color={theme.colors.gray.Cinza_2}>
                                            Carregando dados...
                                        </TaglineP>
                                    ) : (
                                        <TaglineP color={theme.colors.gray.Cinza_2}>
                                            {String(type ? type : "Receitas").toUpperCase()} RESTANTES
                                            {selectedRegistroLinha ? (
                                                <>
                                                    <br />
                                                    {selectedRegistroLinha}
                                                </>
                                            ) : null}
                                        </TaglineP>
                                        )
                                    }
                                </S.CircleData>
                                {(
                                    userData?.contrato?.agro_plan_config?.nome_plano === "PLANO BASIC" ||
                                    userData?.contrato?.agro_plan_config?.nome_plano === "PLANO PRÉ-PAGO"
                                ) && (
                                    <S.CircleTRT>
                                        <GraphicCircle value={credits} maxQuantity={maxQuantity} isCredit />

                                        <TaglineP color={theme.colors.gray.Cinza_2}>
                                            Créditos <br /> disponíveis
                                        </TaglineP>
                                    </S.CircleTRT>
                                )}
                            </>
                        )}
                    </>
                )}
                    
                </S.CirclesContainer>
            </S.Wrapper>
        </S.Container>
    );
};

export default CircleData;